<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Matinées / Soirées Théologiques " />
            <MaTinees />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import MaTinees from '../Matinees/MaTinees.vue'


export default {
    name: 'MatineesPage',
    components: {
        NavBar,
        PageTitle,
        MaTinees,
        FooterComp,
    }
}
</script>